import {
  CONTAINERVERVOER_TIERS,
  OVER_300_KM_RATE_EUR,
  SELLING_PRICE_MARKUP_EUR,
} from "../constants/containervervoerPricing";

export interface ContainervervoerPriceResult {
  basePrice: number;
  sellingPrice: number;
  km: number;
  /** Formula for UI display (without markup). e.g. "€890 + (1069 − 300) km × €1,50" */
  calculationFormula: string;
}

/**
 * Get base and selling price for Containervervoer plaats van bestemming.
 * - km <= 300: lookup tier
 * - km > 300: basePrice = €1132 (first 300 km) + (km - 300) × €1.68
 * - sellingPrice = basePrice + markup
 */
const TIER_300_KM_PRICE = 1132;

export function getContainervervoerPrice(km: number): ContainervervoerPriceResult {
  let basePrice: number;
  let calculationFormula: string;

  if (km > 300) {
    const extraKm = Math.round(km - 300);
    basePrice = TIER_300_KM_PRICE + extraKm * OVER_300_KM_RATE_EUR;
    calculationFormula = `€${TIER_300_KM_PRICE} + (${Math.round(km)} − 300) km × €${OVER_300_KM_RATE_EUR.toLocaleString("nl-NL")}`;
  } else {
    const kmRounded = Math.ceil(km);
    const tier = CONTAINERVERVOER_TIERS.find(
      (t) => kmRounded >= t.kmFrom && kmRounded <= t.kmTo,
    );
    basePrice = tier ? tier.price : 0;
    calculationFormula = tier
      ? `${kmRounded} km (${tier.kmFrom}-${tier.kmTo} km)`
      : `${kmRounded} km`;
  }

  return {
    basePrice,
    sellingPrice: basePrice + SELLING_PRICE_MARKUP_EUR,
    km,
    calculationFormula,
  };
}
